import { NgModule } from '@angular/core';
import { StoreModule } from '@ngrx/store';
import { MOBILE_MENU_FEATURE } from './mobile-menu-state';
import { reducerProvider, reducerToken } from './reducers';

@NgModule({
  imports: [StoreModule.forFeature(MOBILE_MENU_FEATURE, reducerToken)],
  providers: [reducerProvider],
})
export class MobileMenuStoreModule {}
